import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the history movement view.
 * @extends JetView
 */
export default class tableHistoryMovementView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter

        /**
         * Marks the movement type with specific colors.
         * @param {string} value - The movement type value.
         * @returns {string} CSS class for the movement type.
         */
        function mark_new(value) {
            if (value == 'Entrada' || value == 'Entry') {
                return 'lightgreen'; // Color for entry
            } else {
                if (value == 'Salida' || value == 'Output') {
                    return 'highlight'; // Color for exit
                } else {
                    return ''; // Default color
                }
            }
        }

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID of the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: true, // Enable vertical scrolling
            columns: [
                // Column definitions
                { id: 'Id', header: 'ID', minWidth: 100, adjust: 'data', sort: 'int' }, // ID column, width adjusts to content
                {
                    id: 'UserId',
                    header: _('ID Usuario'), // User ID column with localization
                    minWidth: 100,
                    adjust: 'data', // Width adjusts to content
                    sort: 'int',
                },
                {
                    id: 'Movement',
                    header: _('Movimiento'), // Movement type column with localization
                    options: [
                        { id: '0', value: _('Entrada') }, // Entry option
                        { id: '1', value: _('Salida') }, // Exit option
                        { id: '2', value: _('Cancelación') }, // Cancellation option
                    ],
                    width: 100,
                    sort: 'int',
                    cssFormat: mark_new, // Apply custom CSS formatting
                },
                { id: 'Type', header: _('Tipo'), width: 150, sort: 'int' }, // Type column
                {
                    id: 'ExternalId',
                    header: _('ID Externo'), // External ID column with localization
                    minWidth: 100,
                    adjust: 'data', // Width adjusts to content
                    sort: 'int',
                },
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de creación'), // Creation date column with localization
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'Amount',
                    header: _('Valor'), // Amount column with localization
                    width: 100,
                    sort: 'int',
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                },
                {
                    id: 'BalanceDeposit',
                    header: _('Saldo recargas'), // Deposit balance column with localization
                    width: 100,
                    sort: 'int',
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                },
                {
                    id: 'BalanceWithdrawal',
                    header: _('Saldo retiros'), // Withdrawal balance column with localization
                    width: 100,
                    sort: 'int',
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                },
            ],
            on: {
                // Event handlers for the datatable
                onBeforeLoad: function () {
                    this.showOverlay(
                        // Show loading overlay
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                onAfterLoad: function () {
                    this.hideOverlay(); // Hide loading overlay after data load
                    // Recalculate ID column widths
                    this.adjustColumn('Id', 'data');
                    this.adjustColumn('UserId', 'data');
                    this.adjustColumn('ExternalId', 'data');
                },
            },
            ready: function () {
                if (!this.count()) {
                    // Check if there are no data
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show no data overlay
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        var url =
            devConfig.geturlApi() + // API URL for fetching data
            'es/BalanceHistory/GetBalanceMovement?PlayerId=' +
            cur_user +
            '&';
        var filter = ''; // Filter string for API requests
        const cur_user = this.getParam('user', true); // Get current user parameter
        var flag = false; // Flag for export operation
        const _ = this.app.getService('locale')._; // Localization service

        // Event handler for filtering data
        this.on(this.app, 'historyMovement:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object type filter
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event handler for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });

        // Event handler for export filtering
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set flag for export operation
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first;
            }
            grid.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            grid.attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        // Check if export flag is set
                        var size = grid.getPager().config.size; // Get pager size
                        var page = grid.getPage(); // Get current page
                        var first = size * page; // Calculate first index for export
                        var last = first + size - 1; // Calculate last index for export
                        if ($$('Export').getValue() == '1') {
                            // Check export type
                            for (var j = 0; j < grid.config.columns.length; j++) {
                                if (grid.config.columns[j].exportType) {
                                    delete grid.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Historial de movimientos') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(),
                                    TypeReport: 'Excel', // Set report type to Excel
                                },
                            ]);
                            webix.toExcel(grid, {
                                filter: function (obj) {
                                    return (
                                        grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter data for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Historial de movimientos'),
                                ignore: { detailTittle: true }, // Ignore detail title in export
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                // Check for PDF export
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Historial de movimientos') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(),
                                        TypeReport: 'PDF', // Set report type to PDF
                                    },
                                ]);
                                webix.toPDF(grid, {
                                    filter: function (obj) {
                                        return (
                                            grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter data for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Historial de movimientos'),
                                    autowidth: true, // Enable auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export').setValue(''); // Reset export selection
                    }
                }.bind(this), // Bind context to the function
            );
        });
    }
}

// FILE DOCUMENTED
